import { useColorScheme } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'

// Drives MUI's color scheme, which also sets <html data-theme> for the marketing CSS-Module tokens.
export default function ThemeToggle() {
  const { mode, systemMode, setMode } = useColorScheme()
  // Avoid a hydration/first-paint flash before the scheme resolves.
  if (!mode) return <IconButton aria-label="Toggle theme" size="small" disabled />

  const resolved = mode === 'system' ? systemMode ?? 'light' : mode
  const next = resolved === 'dark' ? 'light' : 'dark'

  return (
    <IconButton
      aria-label={`Switch to ${next} theme`}
      size="small"
      onClick={() => setMode(next)}
      sx={{ color: 'var(--ink-2)' }}
    >
      {resolved === 'dark' ? (
        <LightModeOutlinedIcon fontSize="small" />
      ) : (
        <DarkModeOutlinedIcon fontSize="small" />
      )}
    </IconButton>
  )
}
